module.exports = __webpack_public_path__ + "img/sub17.1fbd502c.jpg";